export default __webpack_public_path__ + "static/install-imagehub-21c5e9a1daac9293c028ed4d46b975ec.webp";